var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    ref: "formPopup",
    attrs: {
      title: _vm.title,
      rightMethod: _vm.onSubmitted,
      rightButtonText: _vm.$t("submit"),
      hasAlert: "",
      large: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          var this$1 = this
          return [
            _c(
              "v-container",
              { staticClass: "compact", attrs: { fluid: "" } },
              [
                _c(
                  "v-layout",
                  { staticClass: "compact-layout", attrs: { row: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { md6: "" } },
                      [
                        _c(
                          "v-card",
                          { attrs: { width: "100%" } },
                          [
                            _c(
                              "v-card-text",
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { "align-baseline": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "title",
                                        attrs: { md3: "" }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("sender")) + ": ")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md4: "" } },
                                      [
                                        _c("vite-autocomplete", {
                                          attrs: {
                                            "hide-details": "",
                                            items: _vm.addresses,
                                            name: "address-template-name",
                                            "return-object": "",
                                            label: _vm.$t("addressName"),
                                            "item-text": "siteName",
                                            "item-value": "siteName"
                                          },
                                          model: {
                                            value: _vm.fromTemplate,
                                            callback: function($$v) {
                                              _vm.fromTemplate = $$v
                                            },
                                            expression: "fromTemplate"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md2: "" } },
                                      [
                                        _c("v-checkbox", {
                                          staticClass: "checkbox",
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("save")
                                          },
                                          model: {
                                            value: _vm.isSaveFrom,
                                            callback: function($$v) {
                                              _vm.isSaveFrom = $$v
                                            },
                                            expression: "isSaveFrom"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md4: "" } },
                                      [
                                        _vm.isSaveFrom
                                          ? _c("v-text-field", {
                                              staticClass: "required_field",
                                              attrs: {
                                                "hide-details": "",
                                                label: _vm.$t("addressName"),
                                                rules: [
                                                  _vm.fieldIsRequired(
                                                    "Site name"
                                                  ),
                                                  function(v) {
                                                    return v ===
                                                      _vm.to.siteName &&
                                                      _vm.isSaveTo
                                                      ? _vm.$t(
                                                          "siteNameIsSameAsToSite"
                                                        )
                                                      : true
                                                  }
                                                ]
                                              },
                                              model: {
                                                value: _vm.from.siteName,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.from,
                                                    "siteName",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression: "from.siteName"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("fullName"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "Full name"
                                                      ),
                                                      _vm.fieldIsFullName(
                                                        _vm.$t("fullName")
                                                      )
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.from.fullName,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.from,
                                                        "fullName",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "from.fullName"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("phone"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "From phone"
                                                      ),
                                                      _vm.fieldCharLimit(
                                                        "Phone",
                                                        10
                                                      )
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.from.phone,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.from,
                                                        "phone",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "from.phone"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "required_field",
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("companyName"),
                                            rules: [_vm.fieldIsRequired()]
                                          },
                                          model: {
                                            value: _vm.from.company,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.from,
                                                "company",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "from.company"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "required_field",
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("address") + " 1",
                                            rules: [
                                              _vm.fieldIsRequired("Address"),
                                              _vm.fieldCharLimit("Address1", 50)
                                            ]
                                          },
                                          model: {
                                            value: _vm.from.address1,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.from,
                                                "address1",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "from.address1"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("address") + " 2",
                                            rules: [
                                              _vm.fieldCharLimit("Address2", 50)
                                            ]
                                          },
                                          model: {
                                            value: _vm.from.address2,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.from,
                                                "address2",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "from.address2"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("city"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "City"
                                                      )
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.from.city,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.from,
                                                        "city",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "from.city"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("vite-autocomplete", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    items: _vm.states,
                                                    label: _vm.$t("state"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "State"
                                                      )
                                                    ]
                                                  },
                                                  scopedSlots: _vm._u([
                                                    {
                                                      key: "item",
                                                      fn: function(data) {
                                                        return [
                                                          [
                                                            _c(
                                                              "v-list-tile-content",
                                                              [
                                                                _c(
                                                                  "v-list-tile-title",
                                                                  {
                                                                    attrs: {
                                                                      id:
                                                                        data.item
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                " +
                                                                        _vm._s(
                                                                          data.item
                                                                        ) +
                                                                        "\n                              "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        ]
                                                      }
                                                    }
                                                  ]),
                                                  model: {
                                                    value: _vm.from.state,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.from,
                                                        "state",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "from.state"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "required_field",
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("zipCode"),
                                            rules: [
                                              _vm.fieldIsRequired("Zip code")
                                            ]
                                          },
                                          model: {
                                            value: _vm.from.zipCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.from,
                                                "zipCode",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "from.zipCode"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: "EIN",
                                                    rules: [
                                                      _vm.fieldIsRequired(),
                                                      _vm.fieldCharLimit(
                                                        "EIN",
                                                        9
                                                      )
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.from.partyId,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.from,
                                                        "partyId",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "from.partyId"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("email")
                                                  },
                                                  model: {
                                                    value: _vm.from.email,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.from,
                                                        "email",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "from.email"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("vite-autocomplete", {
                                          attrs: {
                                            "hide-details": "",
                                            items: [
                                              {
                                                name: _vm.$t("unitedStates"),
                                                value: "US"
                                              }
                                            ],
                                            "item-text": "name",
                                            "item-value": "value",
                                            label: _vm.$t("country")
                                          },
                                          model: {
                                            value: _vm.from.countryCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.from,
                                                "countryCode",
                                                $$v
                                              )
                                            },
                                            expression: "from.countryCode"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { md6: "" } },
                      [
                        _c(
                          "v-card",
                          { attrs: { width: "100%" } },
                          [
                            _c(
                              "v-card-text",
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { "align-baseline": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "title",
                                        attrs: { md3: "" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("recipient")) + ": "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md4: "" } },
                                      [
                                        _c("vite-autocomplete", {
                                          attrs: {
                                            "hide-details": "",
                                            items: _vm.addresses,
                                            "return-object": "",
                                            label: _vm.$t("addressName"),
                                            "item-text": "siteName",
                                            "item-value": "siteName"
                                          },
                                          model: {
                                            value: _vm.toTemplate,
                                            callback: function($$v) {
                                              _vm.toTemplate = $$v
                                            },
                                            expression: "toTemplate"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md2: "" } },
                                      [
                                        _c("v-checkbox", {
                                          staticClass: "checkbox",
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("save")
                                          },
                                          model: {
                                            value: _vm.isSaveTo,
                                            callback: function($$v) {
                                              _vm.isSaveTo = $$v
                                            },
                                            expression: "isSaveTo"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { md4: "" } },
                                      [
                                        _vm.isSaveTo
                                          ? _c("v-text-field", {
                                              staticClass: "required_field",
                                              attrs: {
                                                "hide-details": "",
                                                label: _vm.$t("addressName"),
                                                rules: [
                                                  _vm.fieldIsRequired(
                                                    "Site name"
                                                  ),
                                                  function(v) {
                                                    return v ===
                                                      _vm.from.siteName &&
                                                      _vm.isSaveFrom
                                                      ? this$1.$t(
                                                          "siteNameIsSameAsToSite"
                                                        )
                                                      : true
                                                  }
                                                ]
                                              },
                                              model: {
                                                value: _vm.to.siteName,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.to,
                                                    "siteName",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression: "to.siteName"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("fullName"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "Full name"
                                                      ),
                                                      _vm.fieldCharLimit(
                                                        "Full name",
                                                        35
                                                      )
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.to.fullName,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.to,
                                                        "fullName",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "to.fullName"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("phone")
                                                  },
                                                  model: {
                                                    value: _vm.to.phone,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.to,
                                                        "phone",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "to.phone"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("companyName"),
                                            rules: [_vm.fieldIsRequired()]
                                          },
                                          model: {
                                            value: _vm.to.company,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.to,
                                                "company",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "to.company"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "required_field",
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("address") + " 1",
                                            rules: [
                                              _vm.fieldIsRequired("Address"),
                                              _vm.fieldCharLimit("address", 50)
                                            ]
                                          },
                                          model: {
                                            value: _vm.to.address1,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.to,
                                                "address1",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "to.address1"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("address") + " 2",
                                            rules: [
                                              _vm.fieldCharLimit("Address2", 50)
                                            ]
                                          },
                                          model: {
                                            value: _vm.to.address2,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.to,
                                                "address2",
                                                typeof $$v === "string"
                                                  ? $$v.trim()
                                                  : $$v
                                              )
                                            },
                                            expression: "to.address2"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "required_field",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("city"),
                                                    rules: [
                                                      _vm.fieldIsRequired(
                                                        "City"
                                                      )
                                                    ]
                                                  },
                                                  model: {
                                                    value: _vm.to.city,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.to,
                                                        "city",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "to.city"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("state")
                                                  },
                                                  model: {
                                                    value: _vm.to.state,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.to,
                                                        "state",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "to.state"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-around": "",
                                              "align-baseline": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("zipCode")
                                                  },
                                                  model: {
                                                    value: _vm.to.zipCode,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.to,
                                                        "zipCode",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "to.zipCode"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { top: "" },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "activator",
                                                        fn: function(ref) {
                                                          var on = ref.on
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.googleMapDisabled,
                                                                    icon: "",
                                                                    flat: "",
                                                                    color:
                                                                      "primary",
                                                                    small: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.goToGoogleMapLink.apply(
                                                                        null,
                                                                        arguments
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "location_on"
                                                                  )
                                                                ])
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ])
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t("googleMap")
                                                          )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs7: "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            attrs: {
                                              "justify-space-between": ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: "EIN"
                                                  },
                                                  model: {
                                                    value: _vm.to.partyId,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.to,
                                                        "partyId",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "to.partyId"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs5: "" } },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t("email")
                                                  },
                                                  model: {
                                                    value: _vm.to.email,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.to,
                                                        "email",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression: "to.email"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs4: "" } },
                                      [
                                        _c("vite-autocomplete", {
                                          staticClass: "required_field",
                                          attrs: {
                                            "hide-details": "",
                                            items: _vm.countryCodeArray,
                                            "item-text": "name",
                                            "item-value": "value",
                                            label: _vm.$t("country"),
                                            rules: [
                                              _vm.fieldIsRequired("Country")
                                            ]
                                          },
                                          model: {
                                            value: _vm.to.countryCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.to,
                                                "countryCode",
                                                $$v
                                              )
                                            },
                                            expression: "to.countryCode"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { "align-baseline": "" } },
                  [
                    _c(
                      "v-flex",
                      [
                        _c(
                          "v-card",
                          {
                            staticClass: "compact-card",
                            attrs: { width: "100%" }
                          },
                          [
                            _c(
                              "v-card-text",
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { "align-baseline": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "title",
                                        attrs: { md3: "" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("shipmentInfo")) + ": "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-layout",
                                  { attrs: { "justify-space-between": "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { xs2: "" } },
                                      [
                                        _c("vite-autocomplete", {
                                          attrs: {
                                            "hide-details": "",
                                            items: [
                                              {
                                                name: _vm.$t("directConsumer"),
                                                value: "directConsumer"
                                              },
                                              {
                                                name: _vm.$t(
                                                  "governmentEntity"
                                                ),
                                                value: "governmentEntity"
                                              },
                                              {
                                                name: _vm.$t("reseller"),
                                                value: "reseller"
                                              },
                                              {
                                                name: _vm.$t("other"),
                                                value: "other"
                                              }
                                            ],
                                            "item-text": "name",
                                            "item-value": "value",
                                            label: _vm.$t(
                                              "ultimateConsigneeType"
                                            ),
                                            readonly: ""
                                          },
                                          model: {
                                            value: _vm.ultimateConsigneeType,
                                            callback: function($$v) {
                                              _vm.ultimateConsigneeType = $$v
                                            },
                                            expression: "ultimateConsigneeType"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs2: "" } },
                                      [
                                        _c("v-autocomplete", {
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("carrierName"),
                                            value: _vm.carrier.name,
                                            items: _vm.carrierItems,
                                            "item-text": "name",
                                            "return-object": ""
                                          },
                                          on: {
                                            change: function(item) {
                                              return (_vm.carrier = item)
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs2: "" } },
                                      [
                                        _c("v-autocomplete", {
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("vesselName"),
                                            value: _vm.carrier.vesselName,
                                            items: _vm.carrierItems,
                                            "item-text": "vesselName",
                                            "return-object": ""
                                          },
                                          on: {
                                            change: function(item) {
                                              return (_vm.carrier = item)
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs2: "" } },
                                      [
                                        _c("v-autocomplete", {
                                          attrs: {
                                            "hide-details": "",
                                            label: _vm.$t("carrierCode"),
                                            value: _vm.carrier.code,
                                            items: _vm.carrierItems,
                                            "item-text": "code",
                                            "return-object": ""
                                          },
                                          on: {
                                            change: function(item) {
                                              return (_vm.carrier = item)
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs2: "" } },
                                      [
                                        _c(
                                          "v-menu",
                                          {
                                            attrs: {
                                              "close-on-content-click": false,
                                              "nudge-right": 40,
                                              lazy: "",
                                              transition: "scale-transition",
                                              "offset-y": "",
                                              "full-width": "",
                                              "min-width": "290px"
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "activator",
                                                fn: function(data) {
                                                  return [
                                                    _c(
                                                      "v-text-field",
                                                      _vm._g(
                                                        {
                                                          attrs: {
                                                            label: _vm.$t(
                                                              "OnBoardDate"
                                                            ),
                                                            "prepend-icon":
                                                              "event",
                                                            readonly: "",
                                                            rules: [
                                                              _vm.fieldIsRequired(
                                                                "On board date"
                                                              )
                                                            ]
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.onboardDate,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.onboardDate = $$v
                                                            },
                                                            expression:
                                                              "onboardDate"
                                                          }
                                                        },
                                                        data.on
                                                      )
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.datePicker,
                                              callback: function($$v) {
                                                _vm.datePicker = $$v
                                              },
                                              expression: "datePicker"
                                            }
                                          },
                                          [
                                            _vm._v(" "),
                                            _c("v-date-picker", {
                                              attrs: {
                                                min: _vm.endDateMinimum.toISOString()
                                              },
                                              on: {
                                                input: function($event) {
                                                  _vm.datePicker = false
                                                }
                                              },
                                              model: {
                                                value: _vm.onboardDate,
                                                callback: function($$v) {
                                                  _vm.onboardDate = $$v
                                                },
                                                expression: "onboardDate"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { staticClass: "compact-layout", attrs: { row: "" } },
                  [
                    _c(
                      "v-flex",
                      [
                        _c(
                          "v-card",
                          { attrs: { width: "100%" } },
                          [
                            _c(
                              "v-card-text",
                              { staticClass: "compact-card-text" },
                              [
                                _c(
                                  "v-layout",
                                  {
                                    staticClass: "title compact-layout",
                                    attrs: {
                                      "align-baseline": "",
                                      "justify-start": ""
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("eei")) +
                                        ":\n                "
                                    ),
                                    _c(
                                      "v-flex",
                                      { attrs: { xs3: "", "ml-4": "" } },
                                      [
                                        _c(
                                          "v-layout",
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs6: "" } },
                                              [
                                                _c("v-combobox", {
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t(
                                                      "commodityTemplate"
                                                    ),
                                                    items:
                                                      _vm.commodityTemplates,
                                                    "item-text": "name",
                                                    "item-value": "key",
                                                    clearable: ""
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.onSelectCommodityTemplate
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs4: "" } },
                                              [
                                                _c("v-text-field", {
                                                  ref: "newTemplateNameInput",
                                                  attrs: {
                                                    "hide-details": "",
                                                    label: _vm.$t(
                                                      "newTemplateName"
                                                    )
                                                  },
                                                  on: {
                                                    keyup: function($event) {
                                                      if (
                                                        !$event.type.indexOf(
                                                          "key"
                                                        ) &&
                                                        _vm._k(
                                                          $event.keyCode,
                                                          "enter",
                                                          13,
                                                          $event.key,
                                                          "Enter"
                                                        )
                                                      ) {
                                                        return null
                                                      }
                                                      return _vm.saveCommodityTemplate.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: _vm.newTemplateName,
                                                    callback: function($$v) {
                                                      _vm.newTemplateName =
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                    },
                                                    expression:
                                                      "newTemplateName"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { xs2: "" } },
                                              [
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { top: "" },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "activator",
                                                        fn: function(ref) {
                                                          var on = ref.on
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                {
                                                                  attrs: {
                                                                    icon: "",
                                                                    loading:
                                                                      _vm.isSavingTemplate,
                                                                    disabled:
                                                                      _vm.isSavingTemplate
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.saveCommodityTemplate
                                                                  }
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v("save")
                                                                ])
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ])
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "saveAsTemplate"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.commodityErrorMessage
                                      ? _c(
                                          "v-flex",
                                          {
                                            staticClass:
                                              "red--text font-weight-bold text-xs-right"
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.commodityErrorMessage
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-data-table", {
                                  staticClass: "elevation-2 mt-2",
                                  attrs: {
                                    headers: _vm.eeiHeaders,
                                    items: _vm.commodities,
                                    "hide-actions": ""
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "headerCell",
                                      fn: function(props) {
                                        return [
                                          props.header.value === "action"
                                            ? _c(
                                                "span",
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { top: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(
                                                              tooltip
                                                            ) {
                                                              return [
                                                                _c(
                                                                  "div",
                                                                  _vm._g(
                                                                    {},
                                                                    tooltip.on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-btn",
                                                                      {
                                                                        attrs: {
                                                                          color:
                                                                            "primary",
                                                                          flat:
                                                                            "",
                                                                          small:
                                                                            "",
                                                                          icon:
                                                                            ""
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            _vm.addEmptyCommodity
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          [
                                                                            _vm._v(
                                                                              "add"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.$t("add")
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(props.header.text)
                                                )
                                              ])
                                        ]
                                      }
                                    },
                                    {
                                      key: "items",
                                      fn: function(props) {
                                        return [
                                          _c(
                                            "tr",
                                            {
                                              staticClass: "commodity-row",
                                              class: {
                                                editing:
                                                  _vm.editingRowIndex ===
                                                  props.index
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.editRow(
                                                    props.index,
                                                    $event
                                                  )
                                                },
                                                mouseleave: _vm.onRowMouseLeave
                                              }
                                            },
                                            [
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "text-xs-center"
                                                },
                                                [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: { top: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var on = ref.on
                                                              return [
                                                                _c(
                                                                  "v-btn",
                                                                  _vm._g(
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "error",
                                                                        flat:
                                                                          "",
                                                                        small:
                                                                          "",
                                                                        icon:
                                                                          "",
                                                                        disabled:
                                                                          _vm
                                                                            .commodities
                                                                            .length ===
                                                                          1
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.deleteCommodity(
                                                                            props.index
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    on
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      [
                                                                        _vm._v(
                                                                          "delete"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("delete")
                                                          )
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c(
                                                    "v-layout",
                                                    { attrs: { row: "" } },
                                                    [
                                                      _c("v-autocomplete", {
                                                        staticClass:
                                                          "table-item",
                                                        staticStyle: {
                                                          "max-width": "200px"
                                                        },
                                                        attrs: {
                                                          value:
                                                            props.item
                                                              .selectedCommodity,
                                                          items:
                                                            _vm.mergedCommoditiesList,
                                                          "item-text":
                                                            "scheduleBDescription",
                                                          "item-value":
                                                            "scheduleBDescription",
                                                          clearable: "",
                                                          label: _vm.$t(
                                                            "commodity"
                                                          ),
                                                          placeholder: _vm.$t(
                                                            "commodities"
                                                          ),
                                                          rules: [
                                                            _vm.fieldIsRequired(
                                                              _vm.$t(
                                                                "commodity"
                                                              )
                                                            )
                                                          ],
                                                          disabled:
                                                            _vm.editingRowIndex !==
                                                            props.index,
                                                          "return-object": ""
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.onComboboxChangeByCommodities(
                                                              $event,
                                                              props.index
                                                            )
                                                          },
                                                          input: function(
                                                            $event
                                                          ) {
                                                            return _vm.onComboboxChangeByCommodities(
                                                              $event,
                                                              props.index
                                                            )
                                                          }
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "item",
                                                              fn: function(
                                                                data
                                                              ) {
                                                                return [
                                                                  _c(
                                                                    "v-list-tile-content",
                                                                    {
                                                                      staticStyle: {
                                                                        "max-width":
                                                                          "300px",
                                                                        "white-space":
                                                                          "normal"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-list-tile-title",
                                                                        {
                                                                          staticStyle: {
                                                                            "white-space":
                                                                              "normal",
                                                                            "word-wrap":
                                                                              "break-word"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              data
                                                                                .item
                                                                                .scheduleBDescription ||
                                                                                data
                                                                                  .item
                                                                                  .description
                                                                            )
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "v-list-tile-sub-title",
                                                                        {
                                                                          staticStyle: {
                                                                            "white-space":
                                                                              "normal",
                                                                            "word-wrap":
                                                                              "break-word"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                              Code: " +
                                                                              _vm._s(
                                                                                data
                                                                                  .item
                                                                                  .scheduleBCode
                                                                              ) +
                                                                              "\n                            "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ]
                                                              }
                                                            },
                                                            {
                                                              key: "no-data",
                                                              fn: function() {
                                                                return [
                                                                  _c(
                                                                    "v-list-tile",
                                                                    [
                                                                      _c(
                                                                        "v-list-tile-content",
                                                                        [
                                                                          _c(
                                                                            "v-list-tile-title",
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                " +
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "noDataAvailable"
                                                                                    )
                                                                                  ) +
                                                                                  "\n                              "
                                                                              )
                                                                            ]
                                                                          )
                                                                        ],
                                                                        1
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ]
                                                              },
                                                              proxy: true
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      }),
                                                      _vm._v(" "),
                                                      _c("v-text-field", {
                                                        staticClass:
                                                          "table-item",
                                                        staticStyle: {
                                                          "max-width": "250px"
                                                        },
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "description"
                                                          ),
                                                          placeholder: _vm.$t(
                                                            "description"
                                                          ),
                                                          rules: [
                                                            _vm.fieldIsRequired(
                                                              _vm.$t(
                                                                "description"
                                                              )
                                                            ),
                                                            _vm.fieldCharLimit(
                                                              "description",
                                                              35
                                                            )
                                                          ],
                                                          disabled:
                                                            _vm.editingRowIndex !==
                                                            props.index
                                                        },
                                                        model: {
                                                          value:
                                                            props.item
                                                              .scheduleBDescription,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              props.item,
                                                              "scheduleBDescription",
                                                              typeof $$v ===
                                                                "string"
                                                                ? $$v.trim()
                                                                : $$v
                                                            )
                                                          },
                                                          expression:
                                                            "props.item.scheduleBDescription"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "table-item required_field",
                                                    attrs: {
                                                      rules: [
                                                        _vm.fieldIsRequired(
                                                          "Schedule B Code"
                                                        ),
                                                        _vm.fieldCharLimit(
                                                          "Schedule B Code",
                                                          10
                                                        )
                                                      ],
                                                      disabled: true,
                                                      readonly: ""
                                                    },
                                                    model: {
                                                      value:
                                                        props.item
                                                          .scheduleBCode,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          props.item,
                                                          "scheduleBCode",
                                                          typeof $$v ===
                                                            "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                        )
                                                      },
                                                      expression:
                                                        "props.item.scheduleBCode"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c("v-autocomplete", {
                                                    staticClass:
                                                      "table-item required_field",
                                                    attrs: {
                                                      items:
                                                        _vm.countryOfOriginList,
                                                      "item-text": "name",
                                                      "item-value": "value",
                                                      rules: [
                                                        _vm.fieldIsRequired(
                                                          _vm.$t(
                                                            "countryOfOrigin"
                                                          )
                                                        )
                                                      ],
                                                      disabled:
                                                        _vm.editingRowIndex !==
                                                        props.index
                                                    },
                                                    model: {
                                                      value:
                                                        props.item
                                                          .countryOfOrigin,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          props.item,
                                                          "countryOfOrigin",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "props.item.countryOfOrigin"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c(
                                                    "v-text-field",
                                                    {
                                                      staticClass:
                                                        "required_field pt-0 table-item qty_unit_filed",
                                                      attrs: {
                                                        rules: [
                                                          _vm.fieldIsRequired(),
                                                          _vm.fieldIsInteger(),
                                                          _vm.fieldIsOverZero()
                                                        ],
                                                        label: _vm.$t(
                                                          "quantity"
                                                        ),
                                                        disabled:
                                                          _vm.editingRowIndex !==
                                                          props.index
                                                      },
                                                      on: {
                                                        input: function(
                                                          $event
                                                        ) {
                                                          return _vm.onQuantityInput(
                                                            props.item
                                                          )
                                                        }
                                                      },
                                                      nativeOn: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          props.item.quantity,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            props.item,
                                                            "quantity",
                                                            _vm._n($$v)
                                                          )
                                                        },
                                                        expression:
                                                          "props.item.quantity"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "template",
                                                        {
                                                          slot: "append-outer"
                                                        },
                                                        [
                                                          _c("v-autocomplete", {
                                                            staticClass:
                                                              "qty_unit",
                                                            attrs: {
                                                              items:
                                                                _vm.inShowChannelUnionList,
                                                              clearable: "",
                                                              rules: [
                                                                _vm.fieldIsRequired(
                                                                  _vm.$t("unit")
                                                                )
                                                              ],
                                                              "item-text":
                                                                "text",
                                                              "item-value":
                                                                "key",
                                                              label: _vm.$t(
                                                                "unit"
                                                              ),
                                                              disabled:
                                                                _vm.editingRowIndex !==
                                                                props.index
                                                            },
                                                            model: {
                                                              value:
                                                                props.item
                                                                  .quantityUnits,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  props.item,
                                                                  "quantityUnits",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "props.item.quantityUnits"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    2
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _vm.isShowQty2(props.item)
                                                    ? _c(
                                                        "v-text-field",
                                                        {
                                                          staticClass:
                                                            "required_field pt-0 table-item qty_unit_filed",
                                                          attrs: {
                                                            rules: [
                                                              _vm.fieldIsRequired(),
                                                              _vm.fieldIsInteger(),
                                                              _vm.fieldIsOverZero()
                                                            ],
                                                            label: _vm.$t(
                                                              "quantity"
                                                            ),
                                                            disabled:
                                                              _vm.editingRowIndex !==
                                                              props.index
                                                          },
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              props.item
                                                                .quantity2,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                props.item,
                                                                "quantity2",
                                                                _vm._n($$v)
                                                              )
                                                            },
                                                            expression:
                                                              "props.item.quantity2"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "template",
                                                            {
                                                              slot:
                                                                "append-outer"
                                                            },
                                                            [
                                                              _c(
                                                                "v-autocomplete",
                                                                {
                                                                  staticClass:
                                                                    "qty_unit",
                                                                  attrs: {
                                                                    items:
                                                                      _vm.inShowUnit2List,
                                                                    clearable:
                                                                      "",
                                                                    rules: [
                                                                      _vm.fieldIsRequired(
                                                                        _vm.$t(
                                                                          "unit"
                                                                        )
                                                                      )
                                                                    ],
                                                                    "item-text":
                                                                      "text",
                                                                    "item-value":
                                                                      "key",
                                                                    label: _vm.$t(
                                                                      "unit"
                                                                    ),
                                                                    disabled:
                                                                      _vm.editingRowIndex !==
                                                                      props.index
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      props.item
                                                                        .quantity2Units,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        props.item,
                                                                        "quantity2Units",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "props.item.quantity2Units"
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "table-item required_field",
                                                    attrs: {
                                                      "hide-details": "",
                                                      prefix: "$",
                                                      rules: [
                                                        _vm.fieldIsRequired(
                                                          _vm.$t("price")
                                                        ),
                                                        _vm.fieldIsOverZero(
                                                          _vm.$t("price")
                                                        ),
                                                        _vm.fieldIsInteger(
                                                          _vm.$t("price")
                                                        )
                                                      ],
                                                      disabled:
                                                        _vm.editingRowIndex !==
                                                        props.index
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        return _vm.onPriceInput(
                                                          props.item
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value: props.item.price,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          props.item,
                                                          "price",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "props.item.price"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "table-item required_field",
                                                    attrs: {
                                                      "hide-details": "",
                                                      value:
                                                        props.item.customsValue,
                                                      rules: [
                                                        _vm.fieldIsRequired(
                                                          _vm.$t("customsValue")
                                                        ),
                                                        _vm.fieldIsOverZero(
                                                          _vm.$t("customsValue")
                                                        )
                                                      ],
                                                      disabled: true
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                { staticClass: "text-xs-left" },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "table-item required_field",
                                                    attrs: {
                                                      "hide-details": "",
                                                      suffix: _vm.isMeasurementMetric
                                                        ? "kg"
                                                        : "Lbs",
                                                      rules: [
                                                        _vm.fieldIsRequired(
                                                          _vm.$t("totalWeight")
                                                        ),
                                                        _vm.fieldIsOverZero(
                                                          _vm.$t("totalWeight")
                                                        )
                                                      ],
                                                      disabled:
                                                        _vm.editingRowIndex !==
                                                        props.index
                                                    },
                                                    model: {
                                                      value:
                                                        props.item
                                                          .commodityWeight,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          props.item,
                                                          "commodityWeight",
                                                          _vm._n($$v)
                                                        )
                                                      },
                                                      expression:
                                                        "props.item.commodityWeight"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6371faae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6371faae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EeiEditPopup.vue
// module id = null
// module chunks = 